import axios from "@/CommonDP/utils/request";
export function pub_rich_content_list(params) {
  return axios({ url: 'pub-rich-content/pageList', params });
}
export function pub_rich_content_save(data) {
  return axios({ method: 'post', url: 'pub-rich-content/save', data });
}
export function pub_rich_content_update(data) {
  return axios({ method: 'post', url: 'pub-rich-content/update', data });
}
export function pub_rich_content_details(params) {
  return axios({ url: '/pub-rich-content/details', params });
}
export function pub_rich_content_delete(params) {
  return axios({ url: '/pub-rich-content/delete', params });
}
